var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGifCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.688 69.654c0-.739-.6-1.344-1.344-1.344-.741 0-1.344.605-1.344 1.344C1 70.396 1.603 71 2.344 71c.743 0 1.344-.604 1.344-1.346z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.688 69.654c0-.739-.6-1.344-1.344-1.344-.741 0-1.344.605-1.344 1.344C1 70.396 1.603 71 2.344 71c.743 0 1.344-.604 1.344-1.346",
    stroke: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.688 56.194A1.345 1.345 0 101 56.19a1.345 1.345 0 002.69.004z",
    fill: "red"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.688 56.194A1.345 1.345 0 101 56.19a1.345 1.345 0 002.69.004",
    stroke: "red"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.688 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.688 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.688 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.688 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.688 15.806a1.344 1.344 0 10-2.687.003 1.344 1.344 0 002.687-.003z",
    fill: "red"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.688 15.806a1.344 1.344 0 10-2.687.003 1.344 1.344 0 002.687-.003",
    stroke: "red"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.688 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.688 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.151 69.654c0-.739-.6-1.344-1.344-1.344a1.345 1.345 0 000 2.69c.743 0 1.344-.604 1.344-1.346z",
    fill: "red"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.151 69.654c0-.739-.6-1.344-1.344-1.344a1.345 1.345 0 000 2.69c.743 0 1.344-.604 1.344-1.346",
    stroke: "red"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.151 56.194a1.344 1.344 0 10-2.689-.004 1.344 1.344 0 002.689.004z",
    fill: "red"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.151 56.194a1.344 1.344 0 10-2.689-.004 1.344 1.344 0 002.689.004",
    stroke: "red"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.151 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.151 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.151 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.151 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.151 15.806a1.344 1.344 0 10-2.687.003 1.344 1.344 0 002.687-.003z",
    fill: "red"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.151 15.806a1.344 1.344 0 10-2.687.003 1.344 1.344 0 002.687-.003",
    stroke: "red"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.151 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.151 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.614 69.654c0-.739-.603-1.344-1.344-1.344-.741 0-1.344.605-1.344 1.344 0 .742.603 1.346 1.344 1.346.741 0 1.344-.604 1.344-1.346z",
    fill: "red"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.614 69.654c0-.739-.603-1.344-1.344-1.344-.741 0-1.344.605-1.344 1.344 0 .742.603 1.346 1.344 1.346.741 0 1.344-.604 1.344-1.346",
    stroke: "red"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.614 56.194c0-.744-.603-1.347-1.344-1.347a1.345 1.345 0 101.344 1.346z",
    fill: "red"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M30.614 56.194c0-.744-.603-1.347-1.344-1.347a1.345 1.345 0 101.344 1.346",
    stroke: "red"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.614 42.73c0-.741-.603-1.344-1.344-1.344-.741 0-1.344.603-1.344 1.344 0 .741.603 1.344 1.344 1.344.741 0 1.344-.603 1.344-1.344z",
    fill: "red"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.614 42.73c0-.741-.603-1.344-1.344-1.344-.741 0-1.344.603-1.344 1.344 0 .741.603 1.344 1.344 1.344.741 0 1.344-.603 1.344-1.344",
    stroke: "red"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.614 29.27c0-.74-.603-1.344-1.344-1.344-.741 0-1.344.603-1.344 1.345 0 .739.603 1.344 1.344 1.344.741 0 1.344-.605 1.344-1.345z",
    fill: "red"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.614 29.27c0-.74-.603-1.344-1.344-1.344-.741 0-1.344.603-1.344 1.345 0 .739.603 1.344 1.344 1.344.741 0 1.344-.605 1.344-1.345",
    stroke: "red"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.614 15.806a1.345 1.345 0 00-2.688 0c0 .741.603 1.346 1.344 1.346.741 0 1.344-.605 1.344-1.346z",
    fill: "red"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.614 15.806a1.345 1.345 0 00-2.688 0c0 .741.603 1.346 1.344 1.346.741 0 1.344-.605 1.344-1.346",
    stroke: "red"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.614 2.344C30.614 1.603 30.01 1 29.27 1c-.741 0-1.344.603-1.344 1.344 0 .741.603 1.344 1.344 1.344.741 0 1.344-.603 1.344-1.344z",
    fill: "red"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.614 2.344C30.614 1.603 30.01 1 29.27 1c-.741 0-1.344.603-1.344 1.344 0 .741.603 1.344 1.344 1.344.741 0 1.344-.603 1.344-1.344",
    stroke: "red"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.075 69.654c0-.739-.6-1.344-1.344-1.344a1.345 1.345 0 000 2.69c.743 0 1.344-.604 1.344-1.346z",
    fill: "red"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.075 69.654c0-.739-.6-1.344-1.344-1.344a1.345 1.345 0 000 2.69c.743 0 1.344-.604 1.344-1.346",
    stroke: "red"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.075 56.194a1.345 1.345 0 10-2.69-.004 1.345 1.345 0 002.69.004z",
    fill: "red"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.075 56.194a1.345 1.345 0 10-2.69-.004 1.345 1.345 0 002.69.004",
    stroke: "red"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.075 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M44.075 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.075 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.075 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.075 15.806a1.344 1.344 0 10-2.687.003 1.344 1.344 0 002.687-.003z",
    fill: "red"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M44.075 15.806a1.344 1.344 0 10-2.687.003 1.344 1.344 0 002.687-.003",
    stroke: "red"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.075 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M44.075 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.54 69.654c0-.739-.603-1.344-1.344-1.344a1.345 1.345 0 000 2.69c.74 0 1.344-.604 1.344-1.346z",
    fill: "red"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M57.54 69.654c0-.739-.603-1.344-1.344-1.344a1.345 1.345 0 000 2.69c.74 0 1.344-.604 1.344-1.346",
    stroke: "red"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.54 56.194a1.344 1.344 0 10-2.687-.003 1.344 1.344 0 002.687.002z",
    fill: "red"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M57.54 56.194a1.344 1.344 0 10-2.687-.003 1.344 1.344 0 002.687.002",
    stroke: "red"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.54 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M57.54 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.54 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M57.54 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.54 15.806a1.345 1.345 0 00-2.688 0c0 .741.6 1.346 1.344 1.346.74 0 1.344-.605 1.344-1.346z",
    fill: "red"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M57.54 15.806a1.345 1.345 0 00-2.688 0c0 .741.6 1.346 1.344 1.346.74 0 1.344-.605 1.344-1.346",
    stroke: "red"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.54 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M57.54 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.999 69.654c0-.739-.601-1.344-1.344-1.344-.74 0-1.344.605-1.344 1.344 0 .742.604 1.346 1.344 1.346.743 0 1.344-.604 1.344-1.346z",
    fill: "red"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 69.654c0-.739-.601-1.344-1.344-1.344-.74 0-1.344.605-1.344 1.344 0 .742.604 1.346 1.344 1.346.743 0 1.344-.604 1.344-1.346",
    stroke: "red"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.999 56.194a1.345 1.345 0 10-2.69-.004 1.345 1.345 0 002.69.004z",
    fill: "red"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 56.194a1.345 1.345 0 10-2.69-.004 1.345 1.345 0 002.69.004",
    stroke: "red"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.999 42.73a1.344 1.344 0 10-2.689 0 1.344 1.344 0 002.689 0z",
    fill: "red"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 42.73a1.344 1.344 0 10-2.689 0 1.344 1.344 0 002.689 0",
    stroke: "red"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.999 29.27a1.344 1.344 0 10-2.689 0 1.344 1.344 0 002.689 0z",
    fill: "red"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 29.27a1.344 1.344 0 10-2.689 0 1.344 1.344 0 002.689 0",
    stroke: "red"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.999 15.806a1.344 1.344 0 10-2.688.003A1.344 1.344 0 0071 15.806z",
    fill: "red"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 15.806a1.344 1.344 0 10-2.688.003A1.344 1.344 0 0071 15.806",
    stroke: "red"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.999 2.344a1.344 1.344 0 10-2.689 0 1.344 1.344 0 002.689 0z",
    fill: "red"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 2.344a1.344 1.344 0 10-2.689 0 1.344 1.344 0 002.689 0",
    stroke: "red"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.463 69.654c0-.739-.6-1.344-1.343-1.344a1.345 1.345 0 000 2.69c.743 0 1.343-.604 1.343-1.346z",
    fill: "red"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M84.463 69.654c0-.739-.6-1.344-1.343-1.344a1.345 1.345 0 000 2.69c.743 0 1.343-.604 1.343-1.346",
    stroke: "red"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.463 56.194a1.344 1.344 0 10-2.688-.004 1.344 1.344 0 002.688.004z",
    fill: "red"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M84.463 56.194a1.344 1.344 0 10-2.688-.004 1.344 1.344 0 002.688.004",
    stroke: "red"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.463 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M84.463 42.73a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.463 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M84.463 29.27a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.463 15.806a1.344 1.344 0 10-2.687.003 1.344 1.344 0 002.688-.003z",
    fill: "red"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M84.463 15.806a1.344 1.344 0 10-2.687.003 1.344 1.344 0 002.688-.003",
    stroke: "red"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.463 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0z",
    fill: "red"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M84.463 2.344a1.344 1.344 0 10-2.688 0 1.344 1.344 0 002.688 0",
    stroke: "red"
  })));
}

export default __webpack_public_path__ + "static/gif-cube.06ebb939.svg";
export { SvgGifCube as ReactComponent };